import { styled } from "styled-components";

export const AdvancedOptionsWrapper = styled.div`
  overflow: clip;
  width: calc(100% + 24px);
  position: relative;
  left: -12px;
`;

export const AdvancedOptionsContainerWrapper = styled.div`
  margin: 0 0 0 -12px;
  padding: 0 12px 4px 24px;
`;

export const AdvancedOptionsContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: stretch;
  margin-top: 24px;
`;
